import {
  Home,
  Building2,
  Globe,
  Megaphone,
  Package,
  Briefcase,
  IdCard,
  Sparkles,
} from "lucide-react";

import { RouteDependency } from "../../../routes/utils";

export type MenuProps = {
  closeMenuMobile: () => void;
  isMobile?: boolean;
};

export type MenuItemType = {
  name: string;
  href: string;
  icon: React.ComponentType<
    React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
  >;
  dependency?: RouteDependency;
};

export interface MenuItemProps {
  item: MenuItemType;
  closeMenuMobile?: () => void;
  isMobile?: boolean;
}

export const menuPrimaryItems: MenuItemType[] = [
  {
    name: "Dashboard",
    icon: Home,
    href: "dashboard",
    dependency: "site",
  },
  {
    name: "Company",
    icon: Building2,
    href: "",
    dependency: "company",
  },
  { name: "Site", icon: Globe, href: "", dependency: "site" },
  {
    name: "Campaigns",
    icon: Megaphone,
    href: "",
    dependency: "campaigns",
  },
  { name: "Products", icon: Package, href: "products", dependency: "site" },
  {
    name: "Smart Docs",
    icon: Sparkles,
    href: "smart-docs",
  },
];

export const menuAdminItems: MenuItemType[] = [
  { name: "Companies", href: "companies", icon: Briefcase },
  { name: "Users", href: "users", icon: IdCard },
];
